<template>
    <div>
        <h3>{{slide.slide.title}}</h3>
        <div 
        v-html="sanitize(slide.slide.corpus)"
        class="highlightable"
        style="text-align: left;"></div>
        <CitationViewer :citations="slide.slide.citations"/>
        <ResourceGallery :resourceList="slide.slide.resources"></ResourceGallery>
        <hr>
        <md-button class="md-raised md-primary" @click="$emit('setDone', [slide.slide.order, true, {}])">
            Continue
        </md-button>
    </div>
</template>

<script>

import ResourceGallery from './Gallery.vue'
import CitationViewer from './CitationViewer.vue'

export default {
    props: {
        slide: {
            type: Object
        },
        sanitize: {
            type: Function
        },
    },
    components: {
        ResourceGallery,
        CitationViewer
    },
    methods: {}
}
</script>

<style scoped>
    div >>> p { 
        margin-top: 0; 
        margin-bottom: 0; 
    }
</style>